<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { ModelListSelect } from "vue-search-select";
import { mapGetters, mapActions, mapState } from "vuex";
import moment from "moment";
import DataTable from "@/components/DataTable.vue";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Shop Purchases Report",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    ModelListSelect,
    DataTable,
  },
  data() {
    return {
      data: {
        datefrom: moment(new Date()).format("YYYY-MM-DD"),
        dateto: moment(new Date()).format("YYYY-MM-DD"),
        supplier: "",
        title: "Purchases Payments Report",
      },
      currentdate: moment(new Date()).format("YYYY-MM-DD"),
      title: "Purchase Payments Report",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Purchases Payments Report",
          active: true,
        },
      ],
      totalRows: 1,
      total_amount: 0,
      pageOptions: [10, 25, 50, 100, 200, 1000],
      serverPerPage: 50,
      IsPurchasePaymentsServerPaginated: true,
      filter: null,
      todoFilter: null,
      filterOn: [],
      filteredData: [],
      todofilterOn: [],
      sortDesc: false,
      fields: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "dateAdded",
          sortable: true,
          label: "DATE TIME",
        },
        {
          key: "supplier",
          sortable: true,
          label: "SUPPLIER",
        },
        {
          key: "amount",
          sortable: true,
          label: "AMOUNT",
        },
        {
          key: "receipt",
          sortable: true,
          label: "RECEIPT NO",
        },
        {
          key: "payments",
          sortable: true,
          label: "COUNT",
        },
        {
          key: "mode",
          sortable: true,
          label: "PAYMENT MODE",
        },
        {
          key: "user",
          sortable: true,
          label: "RECORDED BY",
        },
      ],
      json_fields: {
        DATE_TIME: "dateAdded",
        SUPPLIER: "supplier",
        AMOUNT: "amount",
        RECEIPT: "receipt",
        PAYMENTS_COUNT: "payments",
        PAYMENT_MODE: "mode",
        RECORDED_BY: "user",
      },
      json_meta: [
        [
          {
            key: "charset",
            value: "utf-8",
          },
        ],
      ],
    };
  },

  computed: {
    // MAP STATE
    ...mapState("notification", ["type", "message", "show"]),
    ...mapGetters("purchase", [
      "PurchasePayments",
      "PurchasePaymentsPagination",
      "PurchasePaymentsPaginated",
      "PurchasePaymentsSummary",
      "FilterStatus",
    ]),
    ...mapGetters("stock", ["Suppliers"]),

    rows() {
      return this.IsPurchasePaymentsServerPaginated
        ? this.PurchasePaymentsPagination.total
        : this.PurchasePayments
        ? this.PurchasePayments.length
        : 0;
    },

    perPage: {
      get() {
        if (this.IsPurchasePaymentsServerPaginated) {
          return (
            this.PurchasePaymentsPagination.per_page ||
            this.data.per_page ||
            this.serverPerPage
          );
        } else {
          return this.serverPerPage;
        }
      },
      set(value) {
        if (this.IsPurchasePaymentsServerPaginated) {
          this.data.per_page = value;
          this.data.page = 1;
          this.FetchPurchasesPayments(this.data);
        }
      },
    },

    currentPage: {
      get() {
        return this.PurchasePaymentsPaginated && this.PurchasePaymentsPagination
          ? this.PurchasePaymentsPagination.current_page
          : 1;
      },
      set(value) {
        if (this.PurchasePaymentsPaginated) {
          this.data.page = value;
          this.handlePageChange(value);
        }
      },
    },
  },

  methods: {
    ...mapActions({
      FetchPurchasesPayments: "purchase/fetchPurchasePayments",
      FetchSuppliers: "stock/fetchSuppliers",
    }),

    // COMMA SEPERATORS
    thousandSeperator(m) {
      if (m == null || m === "") return "0";
      const num = Number(m);
      if (isNaN(num)) return "0";

      /* keep sign, add commas, keep up-to 2 decimals */
      return num.toLocaleString("en-US", {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
      });
    },
    SetData() {
      if (this.PurchasePayments) {
        this.filteredData = this.PurchasePayments;
      }
    },
    filterReport() {
      this.FetchPurchasesPayments(this.data);
    },

    handlePageChange(newPage) {
      if (this.IsPurchasePaymentsServerPaginated) {
        this.data.page = newPage;
        this.FetchPurchasesPayments(this.data);
      }
    },
  },

  updated() {
    let total_amount = 0;
    if (this.filteredData) {
      this.filteredData.forEach((item) => {
        total_amount = total_amount + parseInt(item.amount);
      });
      this.total_amount = total_amount;
    }
  },

  watch: {
    PurchasePayments(newValue) {
      if (newValue) {
        this.SetData();
      }
    },
  },

  created() {
    this.FetchPurchasesPayments(this.data);
    this.FetchSuppliers();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-9">
                <h3
                  class="card-title mb-2 text-center"
                  v-html="data.title"
                ></h3>
              </div>
            </div>
            <div class="row">
              <div class="col-md-3 mt-4">
                <download-excel
                  class="btn btn-info"
                  :data="filteredData"
                  :fields="json_fields"
                  :worksheet="'PURCHASE PAYMENTS REPORT FOR' + currentdate"
                  type="csv"
                  :name="'Purchasepayments_report' + currentdate + '.xls'"
                >
                  Export Excel <i class="fa fa-download"></i>
                </download-excel>
              </div>
              <div class="col-md-2 form-group mb-2">
                <label>FROM</label>
                <input
                  type="date"
                  v-model="data.datefrom"
                  class="form-control"
                  v-limit-future-date
                />
              </div>
              <div class="col-md-2 form-group">
                <label>TO</label>
                <input v-model="data.dateto" type="date" class="form-control" v-limit-future-date />
              </div>
              <div class="col-md-3 form-group">
                <label>SUPPLIER</label>
                <model-list-select
                  :list="
                    Suppliers
                      ? [{ id: '', name: 'All Suppliers' }, ...Suppliers]
                      : []
                  "
                  v-model="data.supplier"
                  option-value="id"
                  option-text="name"
                  placeholder="Select Supplier"
                  @input="filterReport()"
                >
                </model-list-select>
              </div>
              <div class="col-md-2 mt-4">
                <button
                  class="btn btn-primary cursor-pointer"
                  type="button"
                  @click="filterReport()"
                >
                  <span class="fa fa-filter cursor-pointer"></span> Filter
                  <b-spinner
                    v-show="FilterStatus"
                    variant="light"
                    small
                    role="status"
                  ></b-spinner>
                </button>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <DataTable
                class="datatables"
                :columns="fields"
                :rows="PurchasePayments"
                :total-rows="rows"
                :pagination="PurchasePaymentsPagination"
                :server-pagination="IsPurchasePaymentsServerPaginated"
                :loading="FilterStatus"
              >
                <template #cell(index)="{ index }">
                  {{ (currentPage - 1) * perPage + index + 1 }}
                </template>
                <template #cell(dateAdded)="{row}">
                  {{ row.dateAdded }}
                </template>
                <template #cell(supplier)="{row}">
                  {{ row.supplier }}
                </template>
                <template #cell(amount)="{row}">
                  {{ thousandSeperator(row.amount) }}
                </template>
                <template #cell(receipt)="{row}">
                  {{ row.receipt }}
                </template>
                <template #cell(payments)="{row}">
                  {{ thousandSeperator(row.payments) }}
                </template>
                <template #cell(mode)="{row}">
                  {{ row.mode }}
                </template>
                <template #cell(user)="{row}">
                  {{ row.user }}
                </template>
              </DataTable>
              <div class="row">
                <div class="col-md-5"></div>
                <div class="col-md-4">
                  <h5>
                    Total Amount:
                    <span class="text-danger">{{
                      thousandSeperator(total_amount)
                    }}</span>
                  </h5>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style>
.btn-primary,
.page-link {
  background-color: #fab031 !important;
  border-color: #fab031 !important;
}
</style>
